/**
 * Preferred locale for API requests (Accept-Language).
 * Uses the user-selected language from i18n; falls back to the browser default.
 * Returns only supported API locales: "tr" | "en"; default "tr".
 */
import i18n from '../config/i18n';

function normalizeToApiLocale(lang: string): string {
  const base = (lang || '').split('-')[0].toLowerCase();
  if (base === 'tr' || base === 'en') return base;
  return 'tr';
}

export function getPreferredApiLocale(): string {
  if (typeof window === 'undefined') return 'tr';
  const lng = i18n.language;
  if (lng) return normalizeToApiLocale(lng);
  const browserLang =
    navigator.language || (navigator.languages && navigator.languages[0]) || '';
  return normalizeToApiLocale(browserLang);
}
